import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
var UpsBarcode = function (_a) {
    var imageSource = _a.imageSource, index = _a.index, totalLen = _a.totalLen;
    return (React.createElement(React.Fragment, null,
        totalLen !== 1 && React.createElement("hr", { className: "sui-mb-4", "data-testid": "divider" }),
        React.createElement(Typography, { variant: "body-lg" },
            "Barcode ",
            index + 1,
            " of ",
            totalLen),
        React.createElement("div", { className: "sui-my-4" },
            React.createElement("img", { className: "sui-max-w-[420px] sui-w-full", key: index, src: imageSource, alt: "UPS Barcode ".concat(index + 1), "data-testid": "ups-barcode-img", height: 116, width: 233 }))));
};
export default UpsBarcode;
